import { createTypographyComponent } from './common';

export const Header = {
  Display4: createTypographyComponent('h1', 'display4', 'Header.Display4'),
  Display3: createTypographyComponent('h1', 'display3', 'Header.Display3'),
  Display2: createTypographyComponent('h1', 'display2', 'Header.Display2'),
  Display1: createTypographyComponent('h2', 'display1', 'Header.Display1'),
  Header2: createTypographyComponent('h2', 'header2', 'Header.Header2'),
  Header1: createTypographyComponent('h3', 'header1', 'Header.Header1'),
  Subheader4: createTypographyComponent('h4', 'subheader4', 'Header.Subheader4'),
  Subheader3: createTypographyComponent('h4', 'subheader3', 'Header.Subheader3'),
  Subheader2: createTypographyComponent('h5', 'subheader2', 'Header.Subheader2'),
  Subheader1: createTypographyComponent('h6', 'subheader1', 'Header.Subheader1'),
};

export const Text = {
  Body4: createTypographyComponent('p', 'body4', 'Text.Body4'),
  Body3: createTypographyComponent('p', 'body3', 'Text.Body3'),
  Body2: createTypographyComponent('p', 'body2', 'Text.Body2'),
  Body1: createTypographyComponent('p', 'body1', 'Text.Body1'),
  BodyShort: createTypographyComponent('p', 'bodyShort', 'Text.BodyShort'),
  Caption2: createTypographyComponent('p', 'caption2', 'Text.Caption2'),
  Caption1: createTypographyComponent('p', 'caption1', 'Text.Caption1'),
};

const Typography = {
  Header,
  Text,
};
export default Typography;
